import React from "react";
import PhotoCollageView from "./photoCollageView";

const AssignmentPhotoCollage = ({ states, funcObj , showResponsePreview}) => {
  const {
    question={},
    isPreview = false,
    index,
    selectData = false,
    frameCollage = [],
    collageLength= 6,
    gradePreview= false,
    showFullPreview =false,
    from = ""
  } = states;
  const { onChangeQuestionData = () => {}, handleCollageChange = () => {} } =
    funcObj;

  const handlerOnChangeData = async (value, key) => {
     onChangeQuestionData(value, key,index);
  };

  return (
    <div className="">
      <PhotoCollageView
         index={index}
        question={question}
        frameCollage={frameCollage}
        selectData={selectData}
        isPreview={isPreview}
        handlerOnChangeData={handlerOnChangeData}
        handleOnChangeUploader={handleCollageChange}
        collageLength={collageLength}
        gradePreview={gradePreview}
        showFullPreview={showFullPreview}
        from={from}
        showResponsePreview={showResponsePreview}
      />
    </div>
  );
};

export default AssignmentPhotoCollage;
